const INITIAL_STATE = {
  productsToCutCablePlanList: []
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'SET_PRODUCTS_TO_CUT': {
      return { ...state, productsToCutCablePlanList: action.productsToCut };
    }
    default:
      return state;
  }
};
